import { useMemo, useRef, useState } from 'react';
import { Button, ButtonGroup, Icon, Label, Popup } from 'semantic-ui-react';
import { getPublishStatus } from 'components/PublishStatus';
import { useDispatch, useSelector } from 'react-redux';
import { clearCreateSuccess as clearCreateSuccessAction, publishContent } from 'actions/publisherAction';
import { IState } from 'reducers/reducers';
import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';
import { CustomTypeWithPublishState } from '../CustomTypeEditor';
import ProgramCodeListModal from '../ProgramCodeListModal';
import { PublisherModal } from '../publisher/Publisher.modal';
import { HeaderWrapper } from './ListHeaderWrapper';
import { ArchiveButton } from './ArchiveButton';
import { PublisherModalRef, PublisherVersionsModal } from '../publisher/PublisherVersions.modal';
import { ModulePreviewButton } from './MyTreatment/ModulePreview';

interface IPropsFromState {
  entry?: CustomTypeWithPublishState;
  isPublisherWorking: boolean;
  createSuccess: boolean;
  createError: string | undefined;
}

export function MyTreatmentModuleHeader(props: ITypeHeaderProps) {
  const { id, type, typeDescription } = props;
  const [confirmPublish, setConfirmPublish] = useState(false);
  const publishModalRef = useRef<PublisherModalRef>();
  const dispatch = useDispatch();

  const { entry, isPublisherWorking, createSuccess, createError } = useSelector<IState, IPropsFromState>((state) => {
    const contentType = type;
    const data = contentType in state.content.data ? state.content.data[contentType] : [];

    return {
      entry: data.find((d) => d._id === id),
      isPublisherWorking: state.publishContent.isWorking,
      createSuccess: state.publishContent.creationSuccess,
      createError: state.publishContent.creationError,
    };
  });
  const { isLive, color, statusText } = useMemo(() => getPublishStatus(entry?.published), [entry?.published]);

  const handlePublishedContent = () => {
    dispatch(publishContent({ id }));
  };

  const handleOpenPublisherModal = () => {
    publishModalRef.current?.setOpen(true);
  };

  if (!typeDescription) return null;

  return (
    <HeaderWrapper>
      {entry?._id && confirmPublish && (
        <PublisherModal
          id={entry?._id}
          open={confirmPublish}
          onCancel={() => setConfirmPublish(false)}
          onConfirm={() => {
            handlePublishedContent();
            setConfirmPublish(false);
          }}
        />
      )}
      {createSuccess && <Label color="green">Success</Label>}
      {createError && (
        <Label color="red">
          Error: {createError}
          <Icon name="delete" onClick={() => dispatch(clearCreateSuccessAction())} />
        </Label>
      )}

      <Popup
        inverted={!isLive || undefined}
        content={statusText}
        position="top center"
        trigger={
          <ButtonGroup>
            <Button
              loading={isPublisherWorking}
              disabled={isPublisherWorking}
              onClick={() => {
                setConfirmPublish(true);
              }}
            >
              Publish
            </Button>

            <Button onClick={handleOpenPublisherModal} style={{ marginRight: '.25em' }} color={color} icon="history" />
          </ButtonGroup>
        }
      />

      <PublisherVersionsModal _ref={publishModalRef} entry={entry} />

      <ModulePreviewButton id={id} revisions={entry?.published} />

      <ProgramCodeListModal id={id} />

      {entry && <ArchiveButton {...props} />}

      {/* WIP: Button overflow ellipsis menu */}
      {/* <Dropdown button icon="ellipsis vertical" floating labeled size="">
          <DropdownMenu direction="left">
            <DropdownItem icon="trash alternate outline" text="Archive" />
            <DropdownItem text="Codes" />
          </DropdownMenu>
        </Dropdown> */}
    </HeaderWrapper>
  );
}
